module.exports = __webpack_public_path__ + "media/images/application/default/default-social-f87f736dcc37cf439c1231c3fc6b8740.jpg";